// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************\\
Chat Window Single Message
\\*********************************/

.roq-chat-message-list-line__content {
  padding: var(--spacing-tiny) var(--spacing-small);
}

/* Chat message main element */
.roq-chat-message {
  display: flex;
}

/* User's avatar */
.roq-avatar {
  align-items: center;
  background-color: var(--color-background-avatar);
  border-radius: var(--border-radius-huge);
  color: var(--color-background);
  display: inline-flex;
  font-weight: var(--font-semibold);
  height: var(--size-avatar);
  justify-content: center;
  min-width: var(--size-avatar);
  text-transform: uppercase;
}

/* The avatar image (svg) wrapper */
.roq-avatar__image {
  border-radius: inherit;
  height: var(--size-avatar);
  width: var(--size-avatar);
}

/* 2. The non-user part of the chat message */
.roq-chat-message__inner {
  max-width: 80%;
}

/* The bubble that wraps the main text, dropdown for edit/delete/reply, "Edited..." text, reply quote */
.roq-chat-message__inner__content {
  background-color: var(--color-background-selected);
  border-radius: var(--border-radius-tiny);
  margin-left: var(--spacing-small);
}

.roq-chat-message__inner__content__message {
  padding: var(--spacing-small);
  position: relative;
}

/* Deleted message text (Deleted) */
.roq-chat-message-deleted-status {
  font-size: var(--font-sm);
  font-style: italic;
  font-weight: var(--font-light);
}

.roq-chat-message-body__mention {
  font-weight: var(--font-semibold);
}

/* If a message is a reply, this container is that */
.roq-chat-message-reply__container {
  background-color: var(--color-background);
  border-radius: var(--border-radius-tiny);
  margin-bottom: var(--spacing-small);
  padding: var(--spacing-small);
}

/* The element that says "Edited..." */
.roq-chat-message-updated-status {
  font-size: var(--font-sm);
  font-style: italic;
  font-weight: var(--font-light);
}

/* Below the bubble (content), so: "Seen" check mark, date */
.roq-chat-message__inner__meta {
  display: flex;
  font-size: var(--font-sm);
  justify-content: right;
  padding: var(--spacing-tiny);
}

/* Message status check mark (sent, delivered, seen) */
.roq-chat-message-status {
  color: var(--color-icons-inactive);
  padding-right: var(--spacing-tiny);
}

.roq-chat-message--seen .roq-chat-message-status {
  color: var(--color-link);
}

.roq-chat-message-list__line--sent .roq-chat-message__inner__content {
  background-color: var(--color-message-sent);
}

/* File preview in the bubble */
.roq-chat-message-file-body {
  cursor: pointer;
  width: var(--size-file-preview-width);
}

.roq-chat-message-file-body__title {
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.roq-chat-message-body__link {
  color: var(--color-link);
}

.roq-chat-message-body__link:hover {
  color: var(--color-link);
  text-decoration: underline;
}

/********************************\\
Chat Window Single Message Replay Quote
\\*********************************/

.roq-chat-message__inner__content__message__status--reply {
  color: var(--color-text-light);
  font-style: italic;
}

.roq-chat-message-reply__header__name {
  font-weight: var(--font-semibold);
}

/* Display only the first paragraph in the reply quote */
.roq-chat-message-reply__content p:not(:first-child) {
  display: none;
}

/* Use ellipsis when reply quote text is too big */
.roq-chat-message-reply__content p {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/********************************\\
Chat Window Message Dropdown
\\*********************************/

/* Dropdown for edit/delete/reply */
.roq-chat-message__inner__content__message__action {
  color: var(--color-icons-hover);
  position: absolute;
  right: 0;
  top: 0;
}

/* .roq-chat-message__inner__content__message bubble */
/* roq-chat-message__inner__content__message__action chevron */

@media (min-width: 768px) {
  --spacing-minus-one: -1px;

  /* Visually hidden */
  .roq-chat-message__inner__content__message:not(:is(:focus-within, :hover))
    .roq-chat-message__inner__content__message__action {
    clip: rect(1px, 1px, 1px, 1px);
    height: 1px;
    margin-left: var(--spacing-minus-one);
    margin-top: var(--spacing-minus-one);
    overflow: hidden;
    position: absolute !important;
    white-space: nowrap;
    width: 1px;
  }
}

.roq-chat-message__inner__content__message__action .roq-action-button__button {
  align-items: center;
  display: flex;
  height: var(--size-message-chevron-height);
  justify-content: center;
  width: var(--size-message-chevron-width);
}

.roq-chat-message-menu,
.roq-chat-conversation-menu {
  background-color: var(--color-background);
  border: var(--border-pale);
  border-radius: var(--border-radius-tiny);
  box-shadow: var(--elevation-4);
  padding: var(--spacing-small);
  z-index: var(--z-modals);
}

.roq-menu-item {
  cursor: pointer;
  padding: var(--spacing-tiny);
}

.roq-menu-item:focus {
  outline: none;
}

.roq-menu-item--disabled {
  color: var(--color-button-disabled);
  /* stylelint-disable-next-line plugin/no-unsupported-browser-features */
  cursor: not-allowed;
}

.roq-menu-item:hover {
  background-color: var(--color-hover-light);
}

.roq-menu-item--disabled:hover {
  background-color: var(--color-background);
}

/** @todo Delete when delete works *dab* */
.roq-chat-message-menu__item-delete {
  display: none;
}

/* @todo Forward message is disabled until we set it up correctly for mobile */
.roq-chat-message-menu__item--forward {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/styles/css/roqChat/_window-message-single.css"],"names":[],"mappings":"AAAA;;kCAEkC;;AAElC;EACE,iDAAiD;AACnD;;AAEA,8BAA8B;AAC9B;EACE,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,gDAAgD;EAChD,wCAAwC;EACxC,8BAA8B;EAC9B,oBAAoB;EACpB,iCAAiC;EACjC,0BAA0B;EAC1B,uBAAuB;EACvB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA,6CAA6C;AAC7C;EACE,cAAc;AAChB;;AAEA,uGAAuG;AACvG;EACE,kDAAkD;EAClD,wCAAwC;EACxC,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,oDAAoD;AACpD;EACE,yCAAyC;EACzC,wCAAwC;EACxC,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA,sCAAsC;AACtC;EACE,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA,sDAAsD;AACtD;EACE,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;;kCAEkC;;AAElC;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA,wDAAwD;AACxD;EACE,aAAa;AACf;;AAEA,kDAAkD;AAClD;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;kCAEkC;;AAElC,mCAAmC;AACnC;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,QAAQ;EACR,MAAM;AACR;;AAEA,sDAAsD;AACtD,8DAA8D;;AAE9D;EACE,yBAAyB;;EAEzB,oBAAoB;EACpB;;IAEE,8BAA8B;IAC9B,WAAW;IACX,qCAAqC;IACrC,oCAAoC;IACpC,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;;EAEE,yCAAyC;EACzC,0BAA0B;EAC1B,wCAAwC;EACxC,8BAA8B;EAC9B,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,uEAAuE;EACvE,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,0CAA0C;AAC1C;EACE,aAAa;AACf;;AAEA,8EAA8E;AAC9E;EACE,aAAa;AACf","sourcesContent":["/********************************\\\nChat Window Single Message\n\\*********************************/\n\n.roq-chat-message-list-line__content {\n  padding: var(--spacing-tiny) var(--spacing-small);\n}\n\n/* Chat message main element */\n.roq-chat-message {\n  display: flex;\n}\n\n/* User's avatar */\n.roq-avatar {\n  align-items: center;\n  background-color: var(--color-background-avatar);\n  border-radius: var(--border-radius-huge);\n  color: var(--color-background);\n  display: inline-flex;\n  font-weight: var(--font-semibold);\n  height: var(--size-avatar);\n  justify-content: center;\n  min-width: var(--size-avatar);\n  text-transform: uppercase;\n}\n\n/* The avatar image (svg) wrapper */\n.roq-avatar__image {\n  border-radius: inherit;\n  height: var(--size-avatar);\n  width: var(--size-avatar);\n}\n\n/* 2. The non-user part of the chat message */\n.roq-chat-message__inner {\n  max-width: 80%;\n}\n\n/* The bubble that wraps the main text, dropdown for edit/delete/reply, \"Edited...\" text, reply quote */\n.roq-chat-message__inner__content {\n  background-color: var(--color-background-selected);\n  border-radius: var(--border-radius-tiny);\n  margin-left: var(--spacing-small);\n}\n\n.roq-chat-message__inner__content__message {\n  padding: var(--spacing-small);\n  position: relative;\n}\n\n/* Deleted message text (Deleted) */\n.roq-chat-message-deleted-status {\n  font-size: var(--font-sm);\n  font-style: italic;\n  font-weight: var(--font-light);\n}\n\n.roq-chat-message-body__mention {\n  font-weight: var(--font-semibold);\n}\n\n/* If a message is a reply, this container is that */\n.roq-chat-message-reply__container {\n  background-color: var(--color-background);\n  border-radius: var(--border-radius-tiny);\n  margin-bottom: var(--spacing-small);\n  padding: var(--spacing-small);\n}\n\n/* The element that says \"Edited...\" */\n.roq-chat-message-updated-status {\n  font-size: var(--font-sm);\n  font-style: italic;\n  font-weight: var(--font-light);\n}\n\n/* Below the bubble (content), so: \"Seen\" check mark, date */\n.roq-chat-message__inner__meta {\n  display: flex;\n  font-size: var(--font-sm);\n  justify-content: right;\n  padding: var(--spacing-tiny);\n}\n\n/* Message status check mark (sent, delivered, seen) */\n.roq-chat-message-status {\n  color: var(--color-icons-inactive);\n  padding-right: var(--spacing-tiny);\n}\n\n.roq-chat-message--seen .roq-chat-message-status {\n  color: var(--color-link);\n}\n\n.roq-chat-message-list__line--sent .roq-chat-message__inner__content {\n  background-color: var(--color-message-sent);\n}\n\n/* File preview in the bubble */\n.roq-chat-message-file-body {\n  cursor: pointer;\n  width: var(--size-file-preview-width);\n}\n\n.roq-chat-message-file-body__title {\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.roq-chat-message-body__link {\n  color: var(--color-link);\n}\n\n.roq-chat-message-body__link:hover {\n  color: var(--color-link);\n  text-decoration: underline;\n}\n\n/********************************\\\nChat Window Single Message Replay Quote\n\\*********************************/\n\n.roq-chat-message__inner__content__message__status--reply {\n  color: var(--color-text-light);\n  font-style: italic;\n}\n\n.roq-chat-message-reply__header__name {\n  font-weight: var(--font-semibold);\n}\n\n/* Display only the first paragraph in the reply quote */\n.roq-chat-message-reply__content p:not(:first-child) {\n  display: none;\n}\n\n/* Use ellipsis when reply quote text is too big */\n.roq-chat-message-reply__content p {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/********************************\\\nChat Window Message Dropdown\n\\*********************************/\n\n/* Dropdown for edit/delete/reply */\n.roq-chat-message__inner__content__message__action {\n  color: var(--color-icons-hover);\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n/* .roq-chat-message__inner__content__message bubble */\n/* roq-chat-message__inner__content__message__action chevron */\n\n@media (min-width: 768px) {\n  --spacing-minus-one: -1px;\n\n  /* Visually hidden */\n  .roq-chat-message__inner__content__message:not(:is(:focus-within, :hover))\n    .roq-chat-message__inner__content__message__action {\n    clip: rect(1px, 1px, 1px, 1px);\n    height: 1px;\n    margin-left: var(--spacing-minus-one);\n    margin-top: var(--spacing-minus-one);\n    overflow: hidden;\n    position: absolute !important;\n    white-space: nowrap;\n    width: 1px;\n  }\n}\n\n.roq-chat-message__inner__content__message__action .roq-action-button__button {\n  align-items: center;\n  display: flex;\n  height: var(--size-message-chevron-height);\n  justify-content: center;\n  width: var(--size-message-chevron-width);\n}\n\n.roq-chat-message-menu,\n.roq-chat-conversation-menu {\n  background-color: var(--color-background);\n  border: var(--border-pale);\n  border-radius: var(--border-radius-tiny);\n  box-shadow: var(--elevation-4);\n  padding: var(--spacing-small);\n  z-index: var(--z-modals);\n}\n\n.roq-menu-item {\n  cursor: pointer;\n  padding: var(--spacing-tiny);\n}\n\n.roq-menu-item:focus {\n  outline: none;\n}\n\n.roq-menu-item--disabled {\n  color: var(--color-button-disabled);\n  /* stylelint-disable-next-line plugin/no-unsupported-browser-features */\n  cursor: not-allowed;\n}\n\n.roq-menu-item:hover {\n  background-color: var(--color-hover-light);\n}\n\n.roq-menu-item--disabled:hover {\n  background-color: var(--color-background);\n}\n\n/** @todo Delete when delete works *dab* */\n.roq-chat-message-menu__item-delete {\n  display: none;\n}\n\n/* @todo Forward message is disabled until we set it up correctly for mobile */\n.roq-chat-message-menu__item--forward {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
